module.exports = __webpack_public_path__ + "static/media/paris-3.1d8a7572.jpg";